module.exports = ['$scope', 'ngMeta', 'bibContentManager', 'settings', '$q', function ($scope, ngMeta, bibContentManager, settings, $q) {
  'use strict';

  function flatten(xs) {
    return xs.reduce((acc, x) => {
      acc = acc.concat(x);
      if (x.contents) {
        acc = acc.concat(flatten(x.contents));
        //x.contents = [];
      }
      return acc;
    }, []);
  }

  var d = $q.defer();
  //, 'EXAMPLE', 'HORIZONTAL_RULE', 'IMAGE_GROUP'
  $scope.$parent.loading = true;
  bibContentManager.getContent(settings.concept.krachtlijnen, ['HORIZONTAL_RULE', 'SECTION', 'MUSIC', 'ATTACHEMENTS_GROUP', 'VIDEO', 'ATTACHMENT', 'PARAGRAPH', 'VIDEO_GROUP', 'ATTACHMENTS_GROUP', 'TERM', 'IMAGE', 'IMAGE_GROUP', 'REFERENCE', 'FOOTNOTE', 'REFERENCE_GROUP', 'EXAMPLE']).then(function (content){
    $scope.document = content;
    $scope.flatDocument = flatten([content]);
    d.resolve(content);
    $scope.$parent.coverImg = content.cover.url;
    $scope.$parent.loading = false;
  });

  $scope.loadedPromise = d.promise;

  $scope.find = function (key) {
    return $scope.flatDocument.filter(o => o.key === key)[0];
  };

  $scope.findNext = function (item) {
    var parent = $scope.find(item.parent.key);
  };

}];



// WEBPACK FOOTER //
// ./web/js/screen/concept/krachtlijnen/conceptKrachtlijnenController.js